import React, { useState } from 'react';
import { CustomIcon } from 'modules/components/layer00';
import { DashboardMetric } from 'modules/components/layer05';
import {
  FilterDailyReportsModal,
  SaveDailyReportModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithMetricsLayout } from 'modules/components/layer32';

import * as ds from './dataService';
import {
  Button,
  Stack,
  useTheme
} from '@mui/material';

import { useParams } from 'react-router-dom';



export type DailyReportsHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DailyReportsHeaderSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const metricNames: (keyof typeof data)[] = [
    'unsubmitted',
    'inspections',
    'accidents',
    'deliveries'
  ];
  return (
    <ActivityHeaderSectionWithMetricsLayout.FC
      title='Daily Reports'
      subtitle=''
      actionButtons={<ActionButtonsGroup />}
      metrics={(
        <Stack
          direction='row'
          columnGap='2rem'
        >{
            metricNames.map((node) => (
              <DashboardMetric.FC
                key={data[node].id}
                metricType={data[node].metricType}
                count={data[node].count}
                title={data[node].title}
              />

            ))
          }
        </Stack>
      )}
    />
  );
};


type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    iSaveDailyReportVisible,
    setISaveDailyReportVisible
  ] = useState(false);



  return (
    <>
      {isVisible && (
        <FilterDailyReportsModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id=''
        />
      )}
      {iSaveDailyReportVisible && (
        <SaveDailyReportModal.FC
          id=''
          isVisible={iSaveDailyReportVisible}
          handleClose={() => setISaveDailyReportVisible(() => false)}
        />
      )}
      <Button
        variant='outlined'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='CALENDARALT'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Jump to Date
      </Button>
      <Button
        variant='outlined'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='FILTER'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Filter
      </Button>
      <Button
        variant='contained'
        color='primary'
        onClick={() => {
          setISaveDailyReportVisible(() => true);
          // navigate(`${DateTime.now().toMillis()}`);
        }}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create Daily Report
      </Button>

    </>
  );
};

